/* eslint-disable */
import { Switch, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Button,
  Dropdown,
  DropdownButton
} from "react-bootstrap";
import { showDecisionAlert, showWarningAlert } from "../../../index";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import CheckPermission from "../../General/CheckPermission";
import RBAC, {
  ModulesName,
  UserActions
} from "../../General/roleModuleActions";
import WorkQueueWounds from "../../pages/resident/workqueuewounds";
import PopupModal from "../modal/popupmodal";
import SkipResidentMsg from "./skipResidentMsg";
import Newresident from "../modal/residentsmodals/newresident";
import ResidentDetails from "./residentdetails";
import ECPReason from "./ecpResidentReason";
import ResidentStatus from "../resident/residentStatus";
import SelectableContext from "react-bootstrap/SelectableContext";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ViewWoundInformationChangeReason from "./viewWoundInformationChangeReason";
import SkipWoundMsg from "./skipWoundMsg";
import Checkbox from "@material-ui/core/Checkbox";

var UpsertNewresident,
  woundAmendModal,
  residentStatusModal,
  noOrderModal,
  addStatusRef,
  residentInfoModal,
  skipECPModal,
  skipHospiceModal,
  showSkipWoundMsgModal = null;

export function BillingResident(props) {
  //#region Resident modal/state
  const [isResidentInfoEdit, setisResidentInfoEdit] = useState(false);
  const [activeEventKey, setActiveEventKey] = useState(null); // null = all closed by default
  const [isNoOrder, setIsNoOrder] = useState(false);
  const [isProcessorNoOrder, setIsProcessorNoOrder] = useState(false);
  const [facilityOrderType, setFacilityOrderType] = useState(null);

  const [Resident, setResident] = useState("");
  const [ResidentID, setResidentID] = useState("");
  const FacilityId = props.facility.id;

  const [residentListUI, setResidentListUI] = useState([]);
  const [residentLoading, setResidentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ShowAdvancedSearch, showAdvanceSearchSectionState] = useState(false);
  const [residentStatus, setResidentStatus] = useState({});
  //#endregion

  const displatWarningAlert = () =>
    showWarningAlert("Coming soon!!!", "Alert");
  const displayDecisionAlert = (title, message) =>
    showDecisionAlert(
      function () {},
      function () {},
      title == null ? "Are you sure?" : title,
      message == null
        ? "You want to deactivate this Resident."
        : message
    );

  useEffect(() => {
    getAllResident();
  }, []);

  const getAllResident = async () => {
    setIsLoading(true);
    var isPartailOrder = props.isPartailOrder ? 1 : 0;
    var partailOrderBillingDate = props.isPartailOrder
      ? props.facility.cycleDate
      : "";
    var processStatusId = props.isPartailOrder
      ? props.processStatusId
      : Common.ProcessStatus.billingQueueID;

    Api.getRequestQry(
      Api.URI_GetAllBillingQueueResidentByFacilityID,
      "?facilityID=" +
        FacilityId +
        "&isPartailOrder=" +
        isPartailOrder +
        "&partailOrderDate=" +
        partailOrderBillingDate +
        "&processStatusId=" +
        processStatusId
    )
      .then((res) => {
        if (res.data.statusCode == 200 && res.data.result != null) {
          if (res.data.result.length > 0) {
            setResidentList(res.data.result);
          } else {
            setResidentListUI([]);
          }
        }
      })
      .catch(() => {})
      .then(() => {
        setIsLoading(false);
        Common.LoadDataTable("residentsList");
      });
    };

    const fixImageUrl = (newURL, fileName) => {

        var res = Resident;
        res.imageUrl = newURL;
        res.faceSheetName = fileName;
        setResident(res);

    }

  const handleResidentStatus = (residentObj) => (event) => {
    if (
      residentObj.isProcessorNoOrder === true &&
      event.target.checked === false
    ) {
      handleResidentNoOrderStatus(residentObj);
    } else {
      let resident = {};
      resident.ResidentID = residentObj.id;
      resident.Status = event.target.checked;
      resident.isPartial = props.isPartailOrder ? 1 : 0;
      if (props.isPartailOrder) {
        resident.partailOrderDate = props.facility.cycleDate;
      }
      updateResidentStatus(resident);
    }
  };

  const updateResidentStatus = (obj) => {
    var msg = obj.Status
      ? "Do you want to process this resident."
      : "You want to move back to review/edit mode?";
    Common.showConfirmation(msg, "Are you sure", updateStatus, null, obj);
  };

  const updateStatus = async (obj) => {
    if (obj) {
      setIsLoading(true);
      var { data } = await Api.postRequest(
        Api.Uri_UpdateBillingSaleOrderStatus,
        obj
      );
      if (data.success) {
        await getAllResident();
        Common.showSuccessAlertAutoClose(
          data.message,
          "success",
          "Success!",
          3000
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
        Common.showSuccessAlert(
          data.message,
          "warning",
          "Warning!",
          3000
        );
      }
    }
  };

  const handleUnReleaseFacility = () => {
    var msg = "You want to un-release facility.";
    Common.showConfirmation(msg, "", unReleaseFacility, null, FacilityId);
  };

  const unReleaseFacility = (facilityId) => {
    setIsLoading(true);
    var obj = {};
    obj.FacilityID = facilityId;
    Api.postRequest(Api.Uri_UnReleaseBillingFacility, obj)
      .then((res) => {
        if (res.data.success) {
          Common.showSuccessAlertAutoClose(
            res.data.message,
            "success",
            "Success!",
            3000
          );
          props.backPress();
        } else {
          if (Array.isArray(res.data.result) && res.data.result.length > 0) {
            Common.showCMNValidationErrors(res.data.message, res.data.result, undefined, res.data.errorGroups);
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "warning",
              "Warning!",
              3000
            );
          }
        }
      })
      .catch(() => {
        Common.showSuccessAlertAutoClose(
          "some error occured while processing your request",
          "warning",
          "Failed!",
          3000
        );
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  const releaseFacility = () => {
    var msg = "You want to release facility.";
    Common.showConfirmation(msg, "", handleReleaseFacility, null, FacilityId);
  };

  const handleResidentStatusActive = async (resident) => {
    setResident(resident);
    residentStatusModal.showModal();
  };

  const handleResidentECP = (obj) => {
    let tempObj = JSON.parse(JSON.stringify(obj));
    if (tempObj.isEcp === false && tempObj.onHospice === true) {
      tempObj.isEcp = !tempObj.isEcp;
      tempObj.onHospice = !tempObj.onHospice;
      var msg =
        "Equal Care cannot be set at the same time as Hospice Retail. Would you like to remove Hospice Retail?";
      Common.showConfirmation(msg, "", updateECPandHospice, null, tempObj);
    } else {
      tempObj.isEcp = !tempObj.isEcp;
      var msg =
        "" +
        (tempObj.isEcp
          ? "You want to set equal care."
          : "You want to remove  equal care.");
      Common.showConfirmation(msg, "", updateECP, null, tempObj);
    }
  };

  const updateECP = (obj) => {
    if (obj) {
      if (obj.isEcp !== false) {
        setResident(obj);
        skipECPModal.showModal();
        getAllResident();
      } else {
        Api.postRequest(Api.apiUrls.updateResidentECP, obj).then((res) => {
          if (res.data.success) {
            getAllResident();
            Common.showSuccessAlertAutoClose(
              "Resident ECP Updated Successfully",
              "success",
              "Success!",
              3000
            );
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "error",
              "Error!",
              3000
            );
          }
        });
      }
    }
  };

  const updateECPandHospice = (obj) => {
    if (obj) {
      if (obj.isEcp !== false) {
        setResident(obj);
        getAllResident();
        skipECPModal.showModal();
      } else {
        Api.postRequest(Api.apiUrls.updateResidentECP, obj).then((res) => {
          if (res.data.success) {
            Api.postRequest(Api.apiUrls.updateResidentHospice, obj).then(
              (res2) => {
                if (res2.data.success) {
                  getAllResident();
                  Common.showSuccessAlertAutoClose(
                    "Resident ECP and Hospice Retail Updated Successfully",
                    "success",
                    "Success!",
                    3000
                  );
                } else {
                  Common.showSuccessAlert(
                    res2.data.message,
                    "error",
                    "Error!",
                    3000
                  );
                }
              }
            );
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "error",
              "Error!",
              3000
            );
          }
        });
      }
    }
  };

  const handleResidentHospice = (obj) => {
    let tempObj = JSON.parse(JSON.stringify(obj));
    if (tempObj.isEcp === true && tempObj.onHospice === false) {
      tempObj.isEcp = !tempObj.isEcp;
      tempObj.onHospice = !tempObj.onHospice;
      var msg =
        "Hospice Retail cannot be set at the same time as Equal Care. Would you like to remove Equal Care?";
      Common.showConfirmation(msg, "", updateECPandHospice, null, tempObj);
    } else {
      tempObj.onHospice = !tempObj.onHospice;
      var msg =
        "" +
        (tempObj.onHospice
          ? "You want to set Hospice Retail."
          : "You want to remove Hospice Retail.");
      Common.showConfirmation(msg, "", updateHospice, null, tempObj);
    }
  };

  const updateHospice = (obj) => {
    if (obj) {
      Api.postRequest(Api.apiUrls.updateResidentHospice, obj).then((res) => {
        if (res.data.success) {
          getAllResident();
          Common.showSuccessAlertAutoClose(
            "Resident Hospice Retail Updated Successfully",
            "success",
            "Success!",
            3000
          );
        } else {
          Common.showSuccessAlert(
            res.data.message,
            "error",
            "Error!",
            3000
          );
        }
      });
    }
  };

  const handleReleaseFacility = (facilityID) => {
    setIsLoading(true);
    var obj = {};
    obj.FacilityID = facilityID;
    Api.postRequest(Api.Uri_UpdateBillingFacilityStatus, obj)
      .then((res) => {
        if (res.data.success) {
          Common.showSuccessAlertAutoClose(
            res.data.message,
            "success",
            "Success!",
            3000
          );
          if (res.data.result) {
            window.location.assign(res.data.result);
          }
          props.backPress();
        } else {
          if (Array.isArray(res.data.result) && res.data.result.length > 0) {
            Common.showCMNValidationErrors(res.data.message, res.data.result, () => handleReleaseFacility(FacilityId), res.data.errorGroups);
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "warning",
              "Warning!",
              3000
            );
          }
        }
      })
      .catch(() => {
        Common.showSuccessAlertAutoClose(
          "some error occured while processing your request",
          "warning",
          "Failed!",
          3000
        );
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  const releasePartailFacility = () => {
    var msg = "Do you want to release partial orders.";
    Common.showConfirmation(
      msg,
      "",
      handleReleaseFacilityPartailOrder,
      null,
      FacilityId
    );
  };

  const handleReleaseFacilityPartailOrder = (facilityID, isRetry = false) => {
    setIsLoading(true);
    const qry =
      "?facilityId=" +
      facilityID +
      "&queueID=" +
      Common.ProcessStatus.billingQueueID +
      "&partailOrderDate=" +
      props.facility.cycleDate +
      (isRetry ? "&isRetry=true" : "");
    Api.getRequestQry(Api.apiUrls.releaseFacilityPartailOrders, qry)
      .then((res) => {
        if (res.data.success) {
          Common.showSuccessAlertAutoClose(
            res.data.message,
            "success",
            "Success!",
            3000
          );
          if (res.data.result) {
            window.location.assign(res.data.result);
          }
          props.backPress();
        } else {
          if (Array.isArray(res.data.result) && res.data.result.length > 0) {
            Common.showCMNValidationErrors(res.data.message, res.data.result, () => handleReleaseFacilityPartailOrder(FacilityId, true), res.data.errorGroups);
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "warning",
              "Warning!",
              3000
            );
          }
        }
      })
      .catch(() => {
        Common.showSuccessAlertAutoClose(
          "some error occured while processing your request",
          "warning",
          "Failed!",
          3000
        );
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleResidentNoOrderStatus = (obj) => {
    let tempObj = JSON.parse(JSON.stringify(obj));
    tempObj.isNoOrder = tempObj.isProcessorNoOrder ? false : true;
    tempObj.isProcessorNoOrder = true;
    var msg =
      "" +
      (tempObj.isNoOrder
        ? "You want to no order."
        : "Ordering for this resident was skipped. The No Order will be removed. Do you want to proceed?");
    Common.showConfirmation(msg, "", updateNoOrderStatus, null, tempObj);
  };

  const updateNoOrderStatus = (obj) => {
    if (obj) {
      setIsNoOrder(obj.isNoOrder);
      setIsProcessorNoOrder(obj.isProcessorNoOrder);

      if (obj.isNoOrder) {
        setResidentID(obj.id);
        noOrderModal.showModal();
      } else {
        Api.postRequest(Api.apiUrls.updateResidentNoOrderStatus, {
          msg: "",
          fkResidentId: obj.id,
          isNoOrder: obj.isNoOrder,
          isProcessorNoOrder: obj.isProcessorNoOrder
        }).then((res) => {
          if (res.data.success) {
            getAllResident();
            Common.showSuccessAlertAutoClose(
              "Resident Status Updated Successfully",
              "success",
              "Success!",
              3000
            );
          } else {
            Common.showSuccessAlert(
              res.data.message,
              "error",
              "Error!",
              3000
            );
          }
        });
      }
    }
  };

  const setResidentList = (list) => {
    const rows = list.map((obj) => {
      const eventKey = obj.id.toString();
      const name = obj.lastName + ", " + obj.firstName;
      const insurance = obj.residentInsuranceList?.length
        ? obj.residentInsuranceList
            .map(
              (ins) =>
                `${ins.isAddEdit ? "*" : ""}${ins.insuranceName}`
            )
            .join(", ")
        : "No insurance on file";

      const statusBadgeType =
        obj.isProcess || obj.isProcessorNoOrder
          ? "badge-success"
          : "badge-warning";
      const statusText = obj.isProcessorNoOrder
        ? "Skipped"
        : obj.isProcess
        ? "Processed"
        : "Pending";

      return (
        <Card key={obj.id} className="mb-4">
          <CardHeader>
            <AccordionToggle
              as="div"
              eventKey={eventKey}
              className="w-100"
              style={{ cursor: "pointer" }}
            >
              <div
                className={`row w-100 d-flex align-items-center border-bottom m-0 py-3 ${
                  obj.isProcess || obj.isProcessorNoOrder
                    ? obj.isProcessorNoOrder
                      ? "bg-light-warning"
                      : "bg-light-success"
                    : ""
                }`}
              >
                {/* Left side – Resident name + info */}
                <div className="flex-grow-1 pl-3">
                  <div className="h5 mb-1">
                    {name} - BT ID: {obj.btPatientBrightreekey}
                  </div>
                  {obj.fkPrimaryPhysicianId == null && (
                    <small className="text-danger">
                      Primary physician is not assigned
                    </small>
                  )}
                  <br />
                  <small className="text-muted">{insurance}</small>
                </div>

                {/* Right side – Badges + Switch + Actions */}
                {!props.isReleasedFacility && (
                  <div
                    className="d-flex align-items-center pr-3"
                    onClick={(e) => e.stopPropagation()} // don't toggle accordion when clicking controls
                  >
                    {obj.isEcp && (
                      <span className="badge badge-success mr-2">
                        ECP
                      </span>
                    )}
                    {obj.onHospice && (
                      <span className="badge badge-success mr-2">
                        HOS
                      </span>
                    )}

                    <span
                      className={`badge badge-lg ${statusBadgeType} mr-4`}
                    >
                      {statusText}
                    </span>

                    <Switch
                      checked={
                        obj.isProcess || obj.isProcessorNoOrder
                      }
                      onChange={handleResidentStatus(obj)}
                      onClick={(e) => e.stopPropagation()}
                      disabled={!props.isProcessorFunctionOn}
                      color="primary"
                    />

                    {props.isProcessorFunctionOn && (
                      <SelectableContext.Provider value={false}>
                        <DropdownButton
                          className="d-inline"
                          drop={"down"}
                          size="xs"
                          variant="primary"
                          title={"Actions"}
                          id={`dropdown-button-drop-actions`}
                          key={"down"}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <CheckPermission
                            permission={UserActions.Update}
                            module={ModulesName.Module_Residents}
                            yes={() => (
                              <Dropdown.Item
                                eventKey="1"
                                onClick={() => {
                                  setResident(obj);
                                  setisResidentInfoEdit(false);
                                  setResidentID(obj.id);
                                  residentInfoModal.showModal();
                                }}
                              >
                                Resident Info
                              </Dropdown.Item>
                            )}
                          />
                          <Dropdown.Item
                            eventKey="8"
                            onClick={() =>
                              handleResidentStatusActive(obj)
                            }
                          >
                            Set Resident Status
                          </Dropdown.Item>

                          <Dropdown.Item
                            eventKey="81"
                            onClick={() => handleResidentECP(obj)}
                          >
                            {obj.isEcp
                              ? "Remove Equal Care"
                              : "Set Equal Care"}
                          </Dropdown.Item>
                          <Dropdown.Item
                            eventKey="8"
                            onClick={() =>
                              handleResidentHospice(obj)
                            }
                          >
                            {obj.onHospice
                              ? "Remove Hospice Retail"
                              : "Set Hospice Retail"}
                          </Dropdown.Item>

                          {(props.facility.fkProcessStatusId ==
                            Common.ProcessStatus.billingQueueID ||
                            props.facility.fkProcessStatusId ==
                              Common.ProcessStatus.workQueueID) && (
                            <CheckPermission
                              userRole={[
                                RBAC.Role_Gentell_SeniorBiller,
                                RBAC.Role_Gentell_IntakeProcessor,
                                RBAC.Role_Gentell_Administrator,
                                RBAC.Role_Gentell_WoundCareSpecialist,
                                RBAC.Role_Gentell_RegionalManager
                              ]}
                              yes={() => (
                                <Dropdown.Item
                                  eventKey="8"
                                  onClick={() =>
                                    handleResidentNoOrderStatus(obj)
                                  }
                                >
                                  {obj.isProcessorNoOrder
                                    ? "Order Products"
                                    : "No Order"}
                                </Dropdown.Item>
                              )}
                            />
                          )}

                          <Dropdown.Item
                            eventKey="2"
                            onClick={() => {
                              setResidentID(obj.id);
                              showSkipWoundMsgModal.showModal();
                            }}
                          >
                            View Skip Wound Messages
                          </Dropdown.Item>

                          <Dropdown.Item
                            eventKey="2"
                            onClick={() => {
                              setResidentID(obj.id);
                              woundAmendModal.showModal();
                            }}
                          >
                            View Wound Amend Details
                          </Dropdown.Item>
                        </DropdownButton>
                      </SelectableContext.Provider>
                    )}
                  </div>
                )}
              </div>
            </AccordionToggle>
          </CardHeader>

          {/* MOUNT only when opened, UNMOUNT when closed */}
          <AccordionCollapse eventKey={eventKey} mountOnEnter unmountOnExit>
            <CardBody>
              <fieldset disabled={obj.isProcess}>
                <WorkQueueWounds
                  facility={props.facility}
                  refresh={props.refresh}
                  isShowProduct={true}
                  Resident={obj}
                  facilityOrderType={props.facilityOrderType}
                  isPartailOrder={props.isPartailOrder}
                  isProcess={obj.isProcess}
                  isBillingQueue={true}
                  isProcessorFunctionOn={props.isProcessorFunctionOn}
                  isReleasedFacility={props.isReleasedFacility}
                  isBTQueue={
                    props.processStatusId ==
                    Common.ProcessStatus.brighreeQueueID
                  }
                  backPress={props.backPress}
                  queue={Common.ProcessStatus.billingQueueID}
                />
              </fieldset>
            </CardBody>
          </AccordionCollapse>
        </Card>
      );
    });

    setResidentListUI(rows);
  };

  const showAdvanceSearchSection = () => {
    showAdvanceSearchSectionState(!ShowAdvancedSearch);
  };

  const toolbar = (
    <div className="card-toolbar">
      <div className="example-tools">
        {!props.isPartailOrder && !props.isReleasedFacility && (
          <>
            <button
              type="button"
              className="mr-5 btn btn-success btn-sm"
              onClick={handleUnReleaseFacility}
            >
              Un-Release Facility
            </button>
            <CheckPermission
              permission={UserActions.Update}
              module={ModulesName.Module_BillingQueue}
              yes={() => (
                <button
                  type="button"
                  disabled={!props.isProcessorFunctionOn}
                  className="mr-5 btn btn-success btn-sm"
                  onClick={releaseFacility}
                >
                  {props.isBTOn === false
                    ? "Print Orders"
                    : "Release To Brightree"}
                </button>
              )}
            />
          </>
        )}

        {props.isPartailOrder && !props.isReleasedFacility && (
          <CheckPermission
            permission={UserActions.Update}
            module={ModulesName.Module_BillingQueue}
            yes={() => (
              <button
                type="button"
                className="mr-5 btn btn-success btn-sm"
                onClick={releasePartailFacility}
              >
                {props.isBTOn === false
                  ? "Print Orders"
                  : "Release Partial Shipment  To Brightree"}
              </button>
            )}
          />
        )}

        <button
          type="button"
          className="mr-5 btn btn-dark btn-sm"
          onClick={props.backPress}
        >
          Back To Facility List
        </button>
      </div>
    </div>
  );

  return (
    <>
      {ShowAdvancedSearch && (
        <Animated
          animationIn="fadeInLeft"
          animationInDuration={800}
          animationOut="fadeOut"
          isVisible={ShowAdvancedSearch}
        >
          <Card>
            <CardHeader title="Search Resident" />
            <CardBody>
              <div
                className="alert border-primary bg-light-primary fade show mb-5"
                role="alert"
              >
                <div className="d-flex align-items-center">
                  <div className="alert-icon">
                    <i className="fas fa-info-circle mr-4 text-primary"></i>
                  </div>
                  <div className="flex-1">
                    <span>
                      Find patients directly, for all statuses:
                      <ol>
                        <li>Use the beginning of first or last name</li>
                        <li>
                          Use full date of birth in mm/dd/yyyy format
                        </li>
                        <li>
                          Use full ssn as nnn-nn-nnnn or nnnnnnnnn format
                        </li>
                      </ol>
                      Otherwise, you will get the whole list for this
                      patient status.
                    </span>
                  </div>
                </div>
              </div>
              <form>
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label
                        className="form-label"
                        htmlFor="PatientName"
                      >
                        Patient Name
                      </label>
                      <input
                        type="text"
                        id="PatientName"
                        className="form-control form-control-sm"
                      />
                      <small>
                        Use 3 or more letters of first or last name
                      </small>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label className="form-label" htmlFor="DOB">
                        DOB
                      </label>
                      <input
                        type="text"
                        id="DOB"
                        className="form-control form-control-sm"
                      />
                      <small>Use mm/dd/yyyy</small>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label className="form-label" htmlFor="SSN">
                        SSN
                      </label>
                      <input
                        type="text"
                        id="SSN"
                        className="form-control form-control-sm"
                      />
                      <small>
                        Must be nnn-nn-nnnn or nnnnnnnnn
                      </small>
                    </div>
                  </div>
                </div>
              </form>
            </CardBody>
            <CardFooter className="d-flex justify-content-end py-3">
              <Button
                variant="success"
                className="mr-5 px-10"
                size="sm"
              >
                Find
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={showAdvanceSearchSection}
              >
                Cancel
              </Button>
            </CardFooter>
          </Card>
        </Animated>
      )}

      <Card className="example example-compact">
        <CardHeader>
          <div className="card-title">
            <div className="row">
              <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8">
                <span>
                  Facility :{" "}
                  <b className="text-success">
                    {props.facility.facilityName}
                  </b>
                  , Purchasing Group-Chain:{" "}
                  {props.facility.chain === ""
                    ? "N/A"
                    : props.facility.chain}
                  , Ownership/Headquarters:{" "}
                  {props.facility.organizationName === ""
                    ? "N/A"
                    : props.facility.organizationName}
                  ,
                  <br />
                  Ship Date:{" "}
                  {props.facility.cycleDate === "1/1/1"
                    ? "N/A"
                    : Common.GetDateString(props.facility.cycleDate) +
                      (props.facility.isSecondaryCycle ? " (S)" : "")}{" "}
                  <FormControlLabel
                    label={
                      <Typography>
                        <h4 className="mt-4"> Part B:</h4>
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        className="mt-2"
                        checked={props.facility.medicarePartBbyGentell}
                        value="checkedA"
                      />
                    }
                  />
                  <FormControlLabel
                    label={
                      <Typography>
                        <h4 className="mt-4"> Equal Care:</h4>
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        className="mt-2"
                        checked={props.facility.isEcp}
                        value="checkedB"
                      />
                    }
                  />
                  <FormControlLabel
                    label={
                      <Typography>
                        <h4 className="mt-4">Outs:</h4>
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        className="mt-2"
                        checked={props.facility.outProgram}
                        value="checkedC"
                      />
                    }
                  />
                </span>
                <h3 className="card-label mt-3">Resident List</h3>
              </div>

              <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                {toolbar}
              </div>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="text-center py-10">
              <span className="spinner spinner-primary"></span>
            </div>
          ) : (
            <Accordion
              activeKey={activeEventKey ?? undefined}
              onSelect={(eventKey) =>
                setActiveEventKey((prev) =>
                  prev === eventKey ? null : eventKey
                )
              }
            >
              {residentListUI}
            </Accordion>
          )}
        </CardBody>
      </Card>

      {/* Modals */}

      <PopupModal
        title="Resident Info"
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          residentInfoModal = ref;
        }}
      >
        {isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4 "
                onClick={() =>
                  setisResidentInfoEdit(!isResidentInfoEdit)
                }
              >
                Go Back To Detail
              </Button>
            </div>
            <Newresident
              ref={(ref) => {
                UpsertNewresident = ref;
              }}
              FacilityId={FacilityId}
              setResidentLoading={setResidentLoading}
              Resident={Resident}
              facility={props.facility}
              close={() => {
                getAllResident(false);
                setResidentLoading(false);
                residentInfoModal.hideModal();
              }}
            />
            <Button
              className="mb-4 btn-success ml-2"
              disabled={residentLoading}
              onClick={() => UpsertNewresident.handleSubmit()}
            >
              <span
                style={{ display: "flex", alignItems: "center" }}
              >
                {residentLoading && (
                  <span className="mr-8 spinner spinner-white"></span>
                )}
                <span>Save Changes</span>
              </span>
            </Button>
          </Animated>
        )}

        {!isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4"
                onClick={() =>
                  setisResidentInfoEdit(!isResidentInfoEdit)
                }
              >
                Edit
              </Button>
            </div>
            <ResidentDetails
              resident={Resident}
                          getAllResident={() => getAllResident(false)}
                          fixImageUrl={fixImageUrl}
            />
          </Animated>
        )}
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Status</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        ref={(ref) => {
          residentStatusModal = ref;
        }}
        showButton={true}
        buttonPress={() => addStatusRef.onSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Update}
      >
        <ResidentStatus
          ref={(ref) => {
            addStatusRef = ref;
          }}
          resident={Resident}
          close={() => {
            getAllResident();
            residentStatusModal.hideModal();
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Wound Amend Messages</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          woundAmendModal = ref;
        }}
      >
        <ViewWoundInformationChangeReason
          residentId={ResidentID}
          woundId={0}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Skip Resident Message</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          noOrderModal = ref;
        }}
      >
        <SkipResidentMsg
          msg={null}
          fkResidentId={ResidentID}
          isNoOrder={isNoOrder}
          isProcessorNoOrder={isProcessorNoOrder}
          onSave={() => {
            noOrderModal.hideModal();
            getAllResident();
          }}
        />
      </PopupModal>

      <PopupModal
        title="ECP Reason"
        ref={(ref) => {
          skipECPModal = ref;
        }}
      >
        <ECPReason
          refresh={() => {
            getAllResident();
            skipECPModal.hideModal();
          }}
          resident={Resident}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Skip Wounds Message</h3>
              <small>
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName === ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain === ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          showSkipWoundMsgModal = ref;
        }}
      >
        <SkipWoundMsg
          fkResidentId={ResidentID}
          isNoOrder={isNoOrder}
          isProcessorNoOrder={isProcessorNoOrder}
          onSave={() => {
            showSkipWoundMsgModal.hideModal();
          }}
        />
      </PopupModal>
    </>
  );
}

export default BillingResident;
